import './offer.scss';

import { Button, OfferCard } from '@/components/Shared/ui';

type TProps = {
  uuid: string;
  img: string;
  name: string;
  status: {
    text: string;
    code: string;
  };
  onSend: () => void;
  sendLoading?: boolean;
  isDisabled?: boolean;
  isAcceptButton: boolean;
  isHasAccepted: boolean;
};

const DraftOffer: React.FC<TProps> = ({
  uuid,
  img,
  name,
  status,
  onSend,
  sendLoading,
  isDisabled,
  isAcceptButton,
  isHasAccepted
}) => {
  const headerActions: React.ReactNode[] = [];

  if (isAcceptButton && !isHasAccepted) {
    headerActions.push(
      <Button
        key={uuid + 'accept'}
        size="small"
        variant="filled-green"
        onClick={!sendLoading ? onSend : undefined}
        isLoading={sendLoading}
        disabled={isDisabled}
      >
        Отправить на рассмотрение
      </Button>
    );
  }

  return (
    <OfferCard key={uuid} status={'default'} statusText={status.text}>
      <OfferCard.Header icon={img} title={name} headerActions={headerActions} />
    </OfferCard>
  );
};

export default DraftOffer;
